// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define;
let is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['lodash4', 'react', '/util/string.js',
    '/www/util/pub/pure_component.js', '/www/locale/pub/i18n_react.js',
    '/www/lum/pub/util/general.js', '/www/lum/pub/util/react.js',
    '/www/lum/pub/util/ucs.js', '/www/lum/pub/comp/ga.js',
    '/www/lum/pub/uikit.js',
    // Import only
    'css!/www/lum/pub/css/btn_icon.css'],
    (_, React, string, Pure_component, {T}, general_util, react_util,
    ucs_util, ga, {Tooltip, Layout: {Flex}},)=>
{
const {qw} = string;
const {get_classname} = general_util;
const {get_btn_comp} = react_util;
const {with_ga} = ga;
const E = {};

const btn_sizes = qw`mini tiny small medium big xl`;
const text_opts = qw`bold primary_text`;
const classnames = `disabled table white light no_link float_left no_hover
    warning circle inverse dark rounded success notification error info
    primary ide`;
const omit_props = btn_sizes.concat(...text_opts, ...qw(classnames));
class Btn_icon_comp extends Pure_component {
    render(){
        let {icon, classes, text, default_tag = 'div', btn_ref,
            tooltip, tooltip_placement, interactive, ...rest} = this.props;
        let classname = get_classname('btn_icon', classes,
            qw`${icon} ${classnames}`, rest);
        let ic_cname = get_classname('btn_icon_ic', '',
            [icon].concat(btn_sizes), {...rest, [icon]: 1});
        let text_cname = get_classname('btn_icon_text', '', qw`mini bold
            primary_text`, {...rest});
        let Btn_comp = get_btn_comp(rest, default_tag);
        if (rest.disabled)
            rest.onClick = _.noop;
        else
            rest.onClick = this.ga_hook_fn(rest.onClick, 'btn_icon_click');
        rest.onMouseEnter = this.ga_hook_fn(rest.onMouseEnter,
            'btn_icon_hover');
        let content = _.isString(text) && <T>{text}</T> || text;
        return <Btn_comp ref={btn_ref} className={classname}
            {..._.omit(rest, omit_props)}>
            <Tooltip tooltip={tooltip} interactive={interactive}
              placement={tooltip_placement}>
                <Flex align_items="center">
                  <div className={ic_cname}/>
                  {!!content &&
                  <div className={text_cname}>{content}</div>}
                </Flex>
            </Tooltip>
          </Btn_comp>
        ;
    }
}
E.Btn_icon = with_ga(Btn_icon_comp);

E.Uc_icon = props=>{
    let {uc, use_text, no_link, only_icon, classes, ...rest} = props;
    uc = _.isString(uc) ? ucs_util.list.by_id[uc] : uc;
    let {id, title, url} = uc||{};
    if (!id)
        return null;
    let btn_props = {
        only_icon: {},
        regular: {tooltip: title, tooltip_placement: 'bottom'},
        use_text: {text: title},
    }[only_icon&&'only_icon'||use_text&&'use_text'||'regular'];
    if (no_link)
        Object.assign(btn_props, {no_link: 1, no_hover: 1});
    else
    {
        Object.assign(btn_props, {to: url, target: '_blank',
            onClick: e=>e.stopPropagation()});
    }
    Object.assign(btn_props, {...rest});
    return <E.Btn_icon id={id} icon={id} {...btn_props} classes={classes} />;
};
E.Uc_icon.displayName = 'Uc_icon';

return E; }); // eslint-disable-line
